<template>
  <div>
    <h2 class="primary--text mb-3">
      Products
    </h2>

    <v-card>
      <v-card-title class="pa-0">
        <v-list-item>
          <v-list-item-avatar class="mr-1">
            <v-icon v-text="'mdi-information-outline'" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="cardTitle" />
            <v-list-item-subtitle
              class="caption"
              v-text="cardSubTitle"
            />
          </v-list-item-content>

          <v-list-item-action>
            <div class="d-flex">
              <!-- <v-btn
                v-if="!productForm.isOpen"
                :loading="products.isUploading"
                outlined
                color="primary"
                class="mx-3 text-transform-none"
                @click="chooseFiles"
              >
                Add via CSV
              </v-btn> -->
              <input
                id="fileUpload"
                type="file"
                accept=".csv"
                hidden
                @change="handleFileUpload"
              >

              <v-btn
                v-if="!productForm.isOpen"
                color="primary"
                depressed
                @click="productForm.isOpen = true"
              >
                Add Product
              </v-btn>
              <v-btn
                v-else
                color="primary"
                outlined
                @click="resetProductForm"
              >
                Cancel
              </v-btn>
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-0">
        <product-list
          v-if="!productForm.isOpen"
          :is-loading="products.isLoading"
          :products="products.list"
          @update-product="openEditForm"
          @displaySnackbar="displaySnackbar"
        />
        <product-form
          v-else
          class="px-6"
          :default-form-values="productForm.formValues"
          @added="resetProductForm"
          @updated="resetProductForm"
          @displaySnackbar="displaySnackbar"
        />
      </v-card-text>
    </v-card>

    <v-snackbar
      v-model="snackbar.isOpen"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import ProductList from '@/components/product-manager/ProductList.vue';
import ProductForm from '@/components/product-manager/ProductForm.vue';

import { productsUpload } from '@/endpoints';
import { parseProducts } from '@/utils/documentParser';
import { productCollection, secureAuthSupplier } from '@/firebase';

function constractFormValues(formValues) {
  return {
    id: formValues.id,
    qty: formValues.qty,
    sku: formValues.sku,
    name: formValues.name,
    location: formValues.location,
    width: formValues.dim.dimension.w,
    length: formValues.dim.dimension.l,
    height: formValues.dim.dimension.h,
    measurementUnit: formValues.dim.unit,
    weight: formValues.weight && formValues.weight.value,
    weightUnit: formValues.weight && formValues.weight.unit,
  };
}

function constructFormData(file) {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
}

export default {
  components: { ProductForm, ProductList },
  data() {
    return {
      products: {
        list: [],
        isLoading: false,
        isUploading: false,
      },
      productForm: {
        isOpen: false,
        formValues: undefined,
      },
      snackbar: {
        text: '',
        isOpen: false,
        color: 'green',
      },
      unSubscribeProducts: () => {},
    };
  },
  computed: {
    cardTitle() {
      if (!this.productForm.isOpen) {
        return 'Products';
      }

      if (this.productForm.formValues) {
        return 'Update Product';
      }

      return 'Add New Product';
    },
    cardSubTitle() {
      if (!this.productForm.isOpen) {
        return 'The table below contains list of all products.';
      }

      if (this.productForm.formValues) {
        return 'Fill the form below to update product.';
      }

      return 'Fill the form below to add new product.';
    },
  },
  mounted() {
    this.fetchProducts();
  },
  beforeDestroy() {
    this.unSubscribeProducts();
  },
  methods: {
    fetchProducts() {
      this.products.isLoading = true;
      this.unSubscribeProducts();

      this.unSubscribeProducts = secureAuthSupplier(productCollection)
        .orderBy('created_at', 'desc')
        .onSnapshot(
          (productSnapshot) => {
            this.products = {
              ...this.products,
              list: productSnapshot.docs.map(parseProducts),
              isLoading: false,
            };
          },
          () => {
            this.displaySnackbar({
              text: 'An error occured. Please try again',
              color: 'red',
            });
            this.products.isLoading = true;
          },
        );
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    handleFileUpload(e) {
      const file = e.target.files[0];
      this.products.isUploading = true;
      document.getElementById('fileUpload').value = '';

      this.axios
        .post(productsUpload, constructFormData(file))
        .then(() => {
          this.products.isUploading = false;
        })
        .catch(() => {
          this.products.isUploading = false;

          this.displaySnackbar({
            color: 'red',
            text: 'Products could not be uploaded',
          });
        });
    },
    openEditForm(formValues) {
      this.productForm = {
        isOpen: true,
        formValues: constractFormValues(formValues),
      };
    },
    resetProductForm() {
      this.productForm = {
        isOpen: false,
        formValues: undefined,
      };
    },
    displaySnackbar({ text, color }) {
      this.snackbar = {
        text,
        color,
        isOpen: true,
      };
    },
  },
};
</script>

<style scoped>
.text-transform-none {
  text-transform: none;
}
</style>
